/**
 * Internal dependencies
 */
import vd from "lib/vd";
import * as actions from "state/action-types";
import { successNotice, errorNotice } from "state/notices/actions";

export default (reportId = null) =>
  (dispatch) => {
    return vd
      .widget(reportId)
      .remove()
      .then(() => {
        dispatch(successNotice("View deleted successfully"));

        dispatch({
          type: actions.DELETE_REPORT_SUCCESS,
          payload: { reportId },
        });
      })
      .catch((error) => {
        dispatch(errorNotice("Failed to delete view"));
        dispatch({
          type: actions.DELETE_REPORT_FAILURE,
          payload: { reportId },
        });
      });
  };
